import Debug from 'debug';
import clone from 'clone';
import _ from 'lodash';
import { fieldFormatter } from '@knack/formatter';
const debug = Debug(`knack.core.helpers.reports.handleProcessReportGroupResults`);
// needs additional work to filter out req object
export const handleProcessReportGroupResults = (req, old_filters, vals, field, group) => {
    debug(`report-controller.handleProcessReportGroupResults`, req);
    debug(vals);
    req.report.filter_groups.push([]);
    let c = 0;
    return _.each(old_filters, function (filter) {
        vals = _.sortBy(vals, function (val) {
            return fieldFormatter.formatField(field, val, `html`, {});
        });
        if (field.type === `number`) {
            vals = vals.sort((a, b) => a - b);
        }
        if (group.sort === `desc`) {
            vals = vals.reverse();
        }
        const used_headers = [];
        _.each(vals, function (val) {
            const new_filter = clone(filter);
            const header = fieldFormatter.formatField(field, val, `html`, {});
            const formattedHeader = _.get(header, field.key, ``);
            debug(`header is: ${formattedHeader}`);
            // exclude repeating filters. this can happen when we have values with decimals on fields that do not display decimal information.
            // for example: values of 1.1 and 1.2 showing no decimal will result in duplicated "1" headers where the values are captured multiple times
            if (_.includes(used_headers, formattedHeader)) {
                return;
            }
            new_filter.push({
                field: field.key,
                operator: `is`,
                value: val,
                header: formattedHeader
            });
            if (formattedHeader !== `` && val !== ``) {
                req.report.filters.push(new_filter);
                if (c === 0) {
                    req.report.filter_groups[req.report.filter_groups.length - 1].push({
                        header: formattedHeader
                    });
                }
            }
            used_headers.push(formattedHeader);
        });
        c++;
    });
};
